import { Injectable } from '@angular/core';
import Constants from 'src/app/shared/constants';
import * as Cookies from 'js-cookie';
import { environment } from 'src/environments/environment';
import { Subject, of } from 'rxjs';
import constants from 'src/app/shared/constants';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  unauthenticated$ = new Subject<string>();
  loggingOut = false;

  loggedIn$ = new Subject();

  constructor(
    private http: HttpClient,
    private router: Router,
    private jwtHelper: JwtHelperService
  ) {}

  isLoggedIn(): boolean {
    const loggedIn = !!Cookies.get(Constants.QUESTIONNAIRE_TOKEN);

    this.loggedIn$.next(loggedIn);

    return loggedIn;
  }

  isXrefUser(): boolean {
    if (!this.isLoggedIn())
      return false;

    const token = this.jwtHelper.decodeToken(Cookies.get(Constants.QUESTIONNAIRE_TOKEN));

    return !!token['is_xref_user'];
  }

  logout(): void {
    this.loggedIn$.next(false);

    // Remove token
    this.removeToken();

    this.router.navigate(['/']);
  }

  redirectToLogin() {
    location.assign(`${environment.LOGIN_URL}?retUrl=${encodeURIComponent(location.href)}`);
  }

  removeToken() {
    Cookies.remove(Constants.QUESTIONNAIRE_TOKEN, {domain: environment.DOMAIN});
    Cookies.remove(constants.AUTH_TOKEN, {domain: environment.DOMAIN});
    Cookies.remove(constants.TRACKING_ID, {domain: environment.DOMAIN});
    this.unauthenticated$.next(null);
  }

  getAuthRetUrl() {
    return Cookies.get(constants.OAUTH_RET_URL_KEY);
  }

  authoriseOauthConnection() {
    const loginOauthQuestionnaire = `${environment.LOGIN_URL}${constants.OAUTH_LOGIN_PATH}`;
    const questionnaireRetUrl = location.href.toString().replace(`${location.protocol}//${location.host}`, '');

    // The users build page is saved as a cookie so it can be retrieved after Oauth and
    // user returned to where they left off
    Cookies.set(
      constants.OAUTH_RET_URL_KEY,
      questionnaireRetUrl,
      {domain: environment.DOMAIN}
    );

    location.assign(`${loginOauthQuestionnaire}`);
  }

  setSessionToken(token: string) {
    Cookies.set(
      constants.QUESTIONNAIRE_TOKEN,
      token,
      {domain: environment.DOMAIN}
    );

    this.loggedIn$.next(true);
  }

  loginWithAccessToken(accessToken: string, region: string) {
    if (!accessToken || !region) {
      return of(null);
    }

    return this.http.post<{ token: string }>(
      `${environment.API}/v1/jwt/obtain/oauth`,
      {region},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'X-OAuth-Bearer-Token': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        }
      }
    ).pipe(
      map((data) => {
        if (data?.token) {
          this.setSessionToken(data.token);
        }
        return data;
      })
    );
  }

}
